import React from 'react';
import { MeetingsEvent } from './MeetingsEvent';
import { observer } from 'src/utils/mobx-react';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { HorseRacingSelectedNew } from 'src/domains/sportsbook/webview/components/racing/NewRacingPage.state';

interface PropsType {
    events: Array<EventId>;
    selected: HorseRacingSelectedNew;
    isBuilding: boolean;
    onChoose?: (eventId: EventId) => void;
}

export const MeetingsRow = observer('MeetingsRow', (props: PropsType): JSX.Element => {
    const { events, selected, isBuilding, onChoose } = props;

    const renderEvents = (): JSX.Element[] => {
        return events.map((eventId: EventId) => (
            <MeetingsEvent
                data-test-event-id={eventId.toOldId()}
                eventId={eventId}
                isBuilding={isBuilding}
                key={eventId.toOldId()}
                onChoose={onChoose}
                selected={selected.isSelected(eventId)}
            />
        ));
    };

    return <>{renderEvents()}</>;
});
